module.exports = __webpack_public_path__ + "static/img/white-logo.3665413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/white-logo.png
// module id = sONV
// module chunks = 15